"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.assertUnreachable = void 0;
/**A call to this function will generate a compiler error if the line is reachable.
 * this is useful for e.g. ensuring that all possible values of a switch statement are handled.
 */
function assertUnreachable(mandatory, ...more) {
    throw new Error("This code should be unreachable");
}
exports.assertUnreachable = assertUnreachable;
